module.exports = __webpack_public_path__ + "img/start-conversion.f5b00048.jpg";